import { createAsyncIcon } from '../../_factory/createAsyncIcon';

// @ts-ignore
const AsyncPhosphorIconFill = createAsyncIcon(() => import('./PhosphorIconFill'));

export default AsyncPhosphorIconFill;

AsyncPhosphorIconFill.displayName = 'AsyncPhosphorIconFill';
